import posthog from 'posthog-js'
import { queryClient } from '@/shared/lib/tanstack'
import { SESSION_QUERY_KEY } from '@/shared/constants/cache'
import { setSecureItem } from '@/shared/lib/storage'
import { getUser } from '@/services/user.services'
import { getJwt } from '@/shared/lib/betterAuth/get-jwt'
import {
  AUTH_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  USER_PROFILE_KEY,
} from '@/shared/constants/auth'
import type { BetterAuthUser } from '@/shared/types/global.types'

interface AuthData {
  token: string
  session?: { token: string }
  user?: BetterAuthUser
}

export async function createUserSession(
  data: AuthData,
  fallbackEmail: string = '',
): Promise<{ identifyEmail: string }> {
  await setSecureItem(AUTH_TOKEN_KEY, data.token)
  await setSecureItem(REFRESH_TOKEN_KEY, data.token)

  const authToken = await getJwt()
  const userData = await getUser(authToken)

  const user = {
    ...userData,
    name: data.user?.name,
    emailVerified: data.user?.emailVerified,
    image: data.user?.image,
    createdAt: data.user?.createdAt,
    updatedAt: data.user?.updatedAt,
    ciUserId: data.user?.ciUserId,
    kanguroUserId: data.user?.kanguroUserId,
    betterAuthUserId: data.user?.id,
  }

  await setSecureItem(USER_PROFILE_KEY, JSON.stringify(user))

  queryClient.clear()

  queryClient.setQueryData(SESSION_QUERY_KEY, {
    session: { token: data.token },
    user,
  })

  const identifyEmail = user?.email ?? fallbackEmail
  if (identifyEmail) {
    posthog.identify(identifyEmail, {
      email: identifyEmail,
      name: user?.name,
    })
  }

  return { identifyEmail }
}
